import { convertStateToParams } from '../utils';
import { authApi } from './auth';
import { mainServiceURL } from './defines';

export const transactionsApi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransaction: builder.query({
      query: (sessionID: string) =>
        mainServiceURL + `/transactions/${sessionID}`,
      providesTags: ['Transactions'],
    }),
    getTransactions: builder.query({
      query: (gridState) => {
        const processedState = convertStateToParams(gridState);
        return {
          url: mainServiceURL + `/transactions`,
          method: 'GET',
          params: processedState,
        };
      },
      providesTags: ['Transactions'],
    }),
    createTransaction: builder.mutation({
      query: (values) => ({
        url: mainServiceURL + `/transactions`,
        method: 'POST',
        body: values,
      }),
    }),
  }),
});

export const {
  useGetTransactionQuery,
  useGetTransactionsQuery,
  useCreateTransactionMutation,
} = transactionsApi;
